const NTQuantityDiscountTeaser = (() => {
  const storageKey = 'nt_quantity_discount_teaser_seen';
  const showDelay = 2000;
  const visibleDuration = 2200;
  const animationBuffer = 260;
  let lastAddedVariantId = null;
  let pendingUntil = 0;
  let timer = null;
  let hideTimer = null;
  let cleanupTimer = null;
  let forceShowNext = false;

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function hasSeenBadge() {
    try {
      return sessionStorage.getItem(storageKey) === 'true';
    } catch (error) {
      return false;
    }
  }

  function markBadgeSeen() {
    try {
      sessionStorage.setItem(storageKey, 'true');
    } catch (error) {
      // sessionStorage can be unavailable in strict privacy modes.
    }
  }

  function getTargetItem(drawer) {
    if (!drawer) return null;

    if (lastAddedVariantId) {
      const variantTarget = drawer.querySelector(
        `.cart-item[data-cart-variant-id="${String(lastAddedVariantId)}"]:not(.hidden)`
      );
      if (variantTarget) return variantTarget;
    }

    return drawer.querySelector('.cart-item:not(.hidden)');
  }

  function reset(drawer) {
    window.clearTimeout(hideTimer);
    window.clearTimeout(cleanupTimer);
    hideTimer = null;
    cleanupTimer = null;
    if (!drawer) return;
    drawer.querySelectorAll('.quantity-discount-teaser-badge.is-visible, .quantity-discount-teaser-badge.is-hiding').forEach((badge) => {
      badge.classList.remove('is-visible', 'is-hiding');
    });
  }

  function animate() {
    const drawer = getDrawer();
    const targetItem = getTargetItem(drawer);
    const plusButton = targetItem && targetItem.querySelector('.cart-quantity .quantity__button[name="plus"]');
    const badge = targetItem && targetItem.querySelector('.quantity-discount-teaser-badge');

    if (!drawer || !targetItem || !plusButton || !badge) return;

    reset(drawer);
    pendingUntil = 0;

    if (forceShowNext || !hasSeenBadge()) {
      forceShowNext = false;
      void badge.offsetWidth;
      badge.classList.add('is-visible');
      markBadgeSeen();
      hideTimer = window.setTimeout(() => {
        badge.classList.add('is-hiding');
        cleanupTimer = window.setTimeout(() => {
          badge.classList.remove('is-visible', 'is-hiding');
        }, animationBuffer);
      }, visibleDuration);
    }
  }

  function request() {
    pendingUntil = Date.now() + showDelay;
    window.clearTimeout(timer);
    timer = window.setTimeout(animate, showDelay);
  }

  function runPendingAfterRender() {
    if (Date.now() > pendingUntil) return;
    window.clearTimeout(timer);
    timer = window.setTimeout(animate, Math.max(0, pendingUntil - Date.now()));
  }

  return {
    request,
    runPendingAfterRender,
    setLastAddedVariant(variantId) {
      lastAddedVariantId = variantId ? String(variantId) : null;
      forceShowNext = Boolean(variantId);
    },
  };
})();

// nt: Tracking-Event pro sichtbarem Oeffnen des Cart Drawers.
//
// Consent: gleiche Kategorie wie die GA4-Tags (analytics), fail closed. Der Drawer geht oft
// auf, bevor der Banner beantwortet ist — deshalb wird die Payload vom Oeffnungszeitpunkt
// gehalten und nach der Zustimmung nachgesendet, statt sie zu verwerfen.
const NT_CART_DRAWER_EVENT = 'nt_cart_drawer_viewed';
const NT_CART_DRAWER_QUEUE_MAX = 10;

let ntCartDrawerConsentAllowed = false;
const ntCartDrawerQueue = [];

function ntReadCartDrawerConsent() {
  try {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    ntCartDrawerConsentAllowed = !!(privacy && privacy.analyticsProcessingAllowed());
  } catch (error) {
    ntCartDrawerConsentAllowed = false;
  }
}

function ntCanPublishCartDrawer() {
  return !!(
    ntCartDrawerConsentAllowed &&
    window.Shopify &&
    Shopify.analytics &&
    typeof Shopify.analytics.publish === 'function'
  );
}

/** @returns {boolean} ob wirklich published wurde — die Queue haengt daran */
function ntSendCartDrawerViewed(payload) {
  if (!ntCanPublishCartDrawer()) return false;

  try {
    Shopify.analytics.publish(NT_CART_DRAWER_EVENT, payload);
  } catch (error) {
    return false; // Tracking darf das Theme nie brechen
  }

  return true;
}

// Die Payload wird erst nach dem /cart.js-Fetch fertig, zwei Oeffnungen kurz hintereinander
// haben also zwei unabhaengige Fetches in der Luft. Der Platz in der Queue wird deshalb
// synchron beim Oeffnen reserviert und erst spaeter gefuellt — sonst wuerde die Reihenfolge
// der Antworten die Reihenfolge der Events bestimmen.
function ntReserveCartDrawerSlot() {
  // Der Deckel verhindert, dass die Queue wachsen kann, wenn die Zustimmung nie kommt.
  if (ntCartDrawerQueue.length >= NT_CART_DRAWER_QUEUE_MAX) return null;

  const slot = { payload: null, dead: false };
  ntCartDrawerQueue.push(slot);
  return slot;
}

function ntFlushCartDrawerQueue() {
  while (ntCartDrawerQueue.length) {
    const slot = ntCartDrawerQueue[0];

    // Fetch fehlgeschlagen: der Platz darf die dahinter nicht blockieren.
    if (slot.dead) {
      ntCartDrawerQueue.shift();
    } else if (!slot.payload) {
      return; // wartet noch auf /cart.js — alles dahinter muss warten
    } else if (ntSendCartDrawerViewed(slot.payload)) {
      ntCartDrawerQueue.shift();
    } else {
      return; // kein Consent oder Publish nicht moeglich: aufheben statt verwerfen
    }
  }
}

function ntOnCartDrawerConsentChange() {
  ntReadCartDrawerConsent();

  // Nicht an der Consent-Flanke haengen, sondern daran, ob wirklich zugestellt wurde: ein
  // Fehlversuch direkt nach der Zustimmung wuerde die Warteschlange sonst fuer den Rest des
  // Seitenaufrufs blockieren. Der Flush ist idempotent — leere Queue heisst kein Publish.
  ntFlushCartDrawerQueue();
}

function ntTrackCartDrawerViewed() {
  const path = window.location.pathname;

  // Auf /cart liefert Shopify das Standard-Event bereits. Die Route exakt gegen die
  // Sprach-Wurzel des Markts pruefen und nicht per Suffix: '/products/cart' oder '/pages/cart'
  // sind Handles, nicht die Cart-Seite, dort wuerde das Tracking sonst still ausfallen.
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const cartPath = `${root}cart`;
  if (path === cartPath || path === `${cartPath}/`) return;

  const slot = ntReserveCartDrawerSlot();
  if (!slot) return; // Deckel erreicht: nichts holen, nichts halten

  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then((response) => response.json())
    .then((cart) => {
      slot.payload = { cart };
      ntFlushCartDrawerQueue();
    })
    .catch(() => {
      // Tracking darf das Theme nie brechen
      slot.dead = true;
      ntFlushCartDrawerQueue();
    });
}

// Consent direkt aus der API lesen statt aus event.detail: unabhaengig von der Event-Form und
// damit vom eingesetzten CMP. Der loadFeatures-Callback laeuft ueber denselben Pfad, weil er
// async ist — ein wiederkehrender Besucher mit gespeichertem Consent kann davor schon den
// Drawer geoeffnet haben.
if (window.Shopify && typeof Shopify.loadFeatures === 'function') {
  Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
    if (!error) ntOnCartDrawerConsentChange();
  });
}
document.addEventListener('visitorConsentCollected', ntOnCartDrawerConsentChange);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.openCartDrawer();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    // Nur beim Uebergang geschlossen -> offen tracken, nicht bei Updates im offenen Drawer.
    // Der Zustand haengt an einem eigenen Flag und nicht an der active-Klasse: die wird erst
    // im setTimeout weiter unten gesetzt, zwei open()-Aufrufe vor diesem Task (zwei schnelle
    // Add-to-Cart-Klicks) wuerden also beide "war geschlossen" sehen und doppelt tracken.
    const wasOpen = this.ntIsOpen === true;
    this.ntIsOpen = true;

    if (triggeredBy) this.setActiveElement(triggeredBy);

    if (!wasOpen) ntTrackCartDrawerViewed();

    // Refresh cart content on every open to avoid caching issues
    this.refreshCartContent();
    NTQuantityDiscountTeaser.request();

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        if (containerToTrapFocusOn) trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    // Store current scroll position before setting overflow-hidden (Safari fix)
    this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    document.body.classList.add('overflow-hidden');
    const crossSellSection = this.querySelector('.cross-sell-section');
    if (!crossSellSection) return;
    const crossSellProducts = crossSellSection.querySelector('.cross-sell-section__products');
    if (crossSellSection && crossSellProducts.children.length > 0) {
      crossSellSection.classList.remove('hidden');
      setTimeout(() => {
        crossSellSection.classList.add('animate');
      });
    }
  }

  close() {
    this.classList.remove('active');
    this.ntIsOpen = false;
    removeTrapFocus(this.activeElement);

    // Restore scroll position to prevent Safari from jumping to top
    const storedScrollPosition = this.scrollPosition || 0;
    document.body.classList.remove('overflow-hidden');

    // Safari fix: restore scroll position after removing overflow-hidden
    if (storedScrollPosition > 0) {
      window.scrollTo(0, storedScrollPosition);
    }

    const crossSellSection = this.querySelector('.cross-sell-section');
    if (crossSellSection) {
      crossSellSection.classList.add('hidden');
    }
  }

  refreshCartContent() {
    // Trigger the cart drawer items to refresh using the existing mechanism
    const cartDrawerItems = this.querySelector('cart-drawer-items');
    if (cartDrawerItems && cartDrawerItems.onCartUpdate) {
      cartDrawerItems.onCartUpdate();
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id || parsedState.items?.[0]?.id;
    NTQuantityDiscountTeaser.setLastAddedVariant(this.productId);

    // Store product grid section ID before rendering (it might change after render)
    const productGrid = document.getElementById('product-grid');
    const productGridSectionId = productGrid ? productGrid.dataset.id : null;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
    document.dispatchEvent(new CustomEvent('cart-drawer:loaded'));
    NTQuantityDiscountTeaser.runPendingAfterRender();

    // Refresh product grid and mix-match bar if on mix-match collection page
    // Pass the stored section ID to ensure we use the correct one
    this.refreshProductGrid(productGridSectionId);
    this.refreshMixAndMatchBar();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    const sections = [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
    return sections;
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  refreshProductGrid(sectionIdParam = null) {
    const productGrid = document.getElementById('product-grid');
    const mixMatchCollectionHandle = window.theme?.mixMatchCollectionHandle;
    const currentPath = window.location.pathname;

    if (!productGrid || !mixMatchCollectionHandle || !currentPath.includes(mixMatchCollectionHandle)) return;

    // Use passed section ID if available, otherwise get from current element
    const sectionId = sectionIdParam || productGrid.dataset.id;
    const url = `${window.location.pathname}?section_id=${sectionId}`;

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const productGridContainer = document.getElementById('ProductGridContainer');
        const sourceContainer = html.getElementById('ProductGridContainer');

        if (productGridContainer && sourceContainer) {
          productGridContainer.innerHTML = sourceContainer.innerHTML;

          // Re-trigger scroll animations if needed
          if (typeof initializeScrollAnimationTrigger === 'function') {
            initializeScrollAnimationTrigger(productGridContainer);
          }
        }
      })
      .catch((e) => {
        console.error('Error refreshing product grid:', e);
      });
  }

  refreshMixAndMatchBar() {
    const mixAndMatchBar = document.getElementById('mix-and-match-bar');

    if (!mixAndMatchBar) return;

    const sectionId = mixAndMatchBar.dataset.id;
    const url = `${window.location.pathname}?section_id=${sectionId}`;

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const mixAndMatchBarContainer = document.getElementById('mix-and-match-bar');
        const sourceContainer = html.getElementById('mix-and-match-bar');

        if (mixAndMatchBarContainer && sourceContainer) {
          mixAndMatchBarContainer.innerHTML = sourceContainer.innerHTML;

          // Re-trigger scroll animations if needed
          if (typeof initializeScrollAnimationTrigger === 'function') {
            initializeScrollAnimationTrigger(mixAndMatchBarContainer);
          }
        }
      })
      .catch((e) => {
        console.error('Error refreshing mix and match bar:', e);
      });
  }

  openCartDrawer() {
    if (window.location.search && window.location.search.includes('?cart=open')) {
      setTimeout(() => {
        this.open();
      }, 50);
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

document.addEventListener('cart-drawer:loaded', NTQuantityDiscountTeaser.runPendingAfterRender);
